import { render, staticRenderFns } from "./LabelEmpty.vue?vue&type=template&id=e6d01110&scoped=true"
import script from "./LabelEmpty.vue?vue&type=script&lang=js"
export * from "./LabelEmpty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6d01110",
  null
  
)

export default component.exports